import { render, staticRenderFns } from "./Preference.vue?vue&type=template&id=46cb78de&lang=pug"
import script from "./Preference.vue?vue&type=script&lang=js"
export * from "./Preference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports